import { apiRoutes } from 'config/apiRoutes'
import { useMutation } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { defaultConfig } from 'config/default'
import { downloadAs } from 'utils/downloadFile'
import { getCurrentQuery } from 'utils/getCurrentQuery'
import { useTranslation } from 'libs/i18n'

type UseExportCouponsMutationProps = {
	chosenFormat: number | null
	onSuccess: () => void
	onSettled: () => void
}

export const useExportCouponsMutation = ({
	chosenFormat,
	onSuccess,
	onSettled
}: UseExportCouponsMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: exportCouponsMutation, isPending: isExportCouponsLoading } = useMutation({
		mutationFn: ({ format, ids }: { format: number | null; ids: number[] }) => {
			// No selection: send the list's filters so the export matches what's on screen.
			const query = ids.length ? undefined : getCurrentQuery()
			return axiosPrivate.post(apiRoutes.couponsExport(query), { format, ids })
		},
		onSuccess: (res) => {
			const format = defaultConfig.exportFormatOptions
				.find((format) => format.value === chosenFormat)
				?.label.toLowerCase()

			if (format) {
				downloadAs({ file: res.data, name: 'coupons-export', format })
			}

			onSuccess()
			useToast({
				type: 'success',
				message: t('Coupons exported')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled
	})

	return {
		exportCouponsMutation,
		isExportCouponsLoading
	}
}
